// extracted by mini-css-extract-plugin
export default {"firstBg":"FirstBg_firstBg__X02Ha","vid":"FirstBg_vid__DnW5t","intro":"FirstBg_intro__cEC5p","arrow":"FirstBg_arrow__IZp7y","up-Down":"FirstBg_up-Down__+hbIu"};